const darkmodeToggle = () => {

    const setup = () => {
        // Check for saved user preference on load and apply it
        const userPrefersDark = localStorage.getItem('darkMode') === 'enabled';
        const lightIcon = document.querySelector('.light-icon');
        const darkIcon = document.querySelector('.dark-icon');

        if (userPrefersDark) {
            if (document.body.classList.contains('single-post')) {
                document.body.classList.add('dark');
            }
            if (lightIcon) lightIcon.style.display = 'block';
            if (darkIcon) darkIcon.style.display = 'none';
        } else {
            if (lightIcon) lightIcon.style.display = 'none';
            if (darkIcon) darkIcon.style.display = 'block';
        }
        // Toggle dark mode and save preference
        function toggleDarkMode() {
            document.body.classList.toggle('dark');
            if (document.body.classList.contains('dark')) {
                if (lightIcon) lightIcon.style.display = 'block';
                if (darkIcon) darkIcon.style.display = 'none';
                localStorage.setItem('darkMode', 'enabled');
            } else {
                if (lightIcon) lightIcon.style.display = 'none';
                if (darkIcon) darkIcon.style.display = 'block';
                localStorage.setItem('darkMode', 'disabled');
            }
            
            // Create event when dark mode is toggled
            document.dispatchEvent(new CustomEvent('colorModeChanged'));
        }
    
        const darkModeToggle = document.getElementById('dark-mode-toggle');
        if (darkModeToggle) {
            darkModeToggle.addEventListener('click', toggleDarkMode);
        }
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setup);
    } else {
        setup();
    }

};

const init = () => {
    darkmodeToggle();
};

export default {
    init
};